import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import { translate } from 'react-translate';
import { withRouter } from 'react-router';
import Image from '@components/Image';
import { default as ModalDefault } from '@components/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import images from '@images';
import * as S from './styles';

function renderImage(status) {
  switch (status) {
    case 'checked':
      return <Image src={images.checkcircle} />;
    case 'active':
      return <Image src={images.checkcirclewhite} />;
    case 'disabled':
      return <Image src={images.checkcirclegris} />;
    default:
      return null;
  }
}

class ItemCheck extends Component {
  state = {
    showModal: false,
  };

  openLink = (link) => {
    const {
      props: { status },
    } = this;

    if (status !== 'disabled') {
      if (link !== null && link !== '' && link !== undefined) {
        window.open(link, '_blank');
      } else {
        this.props.completeLater();
      }
    }
  };

  render() {
    const {
      state,
      props: { t, name, status, link },
    } = this;

    return (
      <>
        <ModalDefault
          visible={state.showModal}
          effect="fadeInDown"
          width={530}
          title={t('ATENTION')}
          onClickAway={() => this.setState({ showModal: false })}
          cancelButton={() => this.setState({ showModal: false })}
          cancelButtonText={t('CANCEL')}
          confirmButton={() => window.open(link, '_blank') && this.setState({ showModal: false })}
          confirmButtonText={t('CONFIRM')}
          mobileFullScreen
          iconClose={['fal', 'times']}
        >
          <S.ModalContentWrapper>{t('REDIRECT-BUSINESS')}</S.ModalContentWrapper>
        </ModalDefault>
        <ThemeProvider
          theme={
            status === 'checked'
              ? S.checkedTheme
              : status === 'active'
              ? S.activeTheme
              : S.disabledTheme
          }
        >
          <S.ItemWrapper>
            <S.Circle>{renderImage(status)}</S.Circle>
            <S.Name onClick={() => this.setState({ showModal: true })}>
              {name}
              {status === 'active' && <FontAwesomeIcon icon={['fal', 'chevron-right']} />}
            </S.Name>
          </S.ItemWrapper>
        </ThemeProvider>
      </>
    );
  }
}

export default withRouter(translate('EasyAccess')(ItemCheck));
